import * as SwitchPrimitive from "@radix-ui/react-switch";
import { MoonIcon } from "../icon/icons/MoonIcon";
import { SunIcon } from "../icon/icons/SunIcon";
import { useTheme } from "./ThemeContext";
import {
  themeSwitcherContainer,
  themeSwitcherRoot,
  themeSwitcherThumb,
  valueContainer,
  valueElement,
  valueText
} from "./ThemeSwitcher.css";

export function ThemeSwitcher() {
  const { setTheme, theme } = useTheme();
  const checked = theme === "dark";

  return (
    <div className={themeSwitcherContainer}>
      <SwitchPrimitive.Root
        className={themeSwitcherRoot}
        checked={checked}
        onCheckedChange={(checked) => {
          setTheme(checked ? "dark" : "light");
        }}
        data-state={checked ? "checked" : "unchecked"}
      >
        <SwitchPrimitive.Thumb className={themeSwitcherThumb} />
      </SwitchPrimitive.Root>
      <div className={valueContainer}>
        <div className={valueElement}>
          <SunIcon />
          <div className={valueText}>Light</div>
        </div>
        <div className={valueElement}>
          <MoonIcon />
          <div className={valueText}>Dark</div>
        </div>
      </div>
    </div>
  );
}
